import { z } from 'zod';
export const generateNonceBodySchema = z.object({});
export const generateNonceInputSchema = generateNonceBodySchema;
export const generateNonceOutputSchema = z.string();
